import type { SessionKind } from '../api/SessionKind';

/**
 * The `audience` a mail link carries — `business` or `admin`, the API's own words — as a session kind.
 * Anything else is a business link: that is who receives nearly every mail.
 */
export const kindOfAudience = (audience: string | null): SessionKind =>
  audience === 'admin' ? 'platform' : 'business';

export const audienceOfKind = (kind: SessionKind): string => (kind === 'platform' ? 'admin' : 'business');
